import React from 'react';
import {useContext, createContext} from 'react';
import tagsClient from '../lib/apollo-tags';
import applicationClient from '../lib/apollo';

const value = {
    tags: tagsClient,
    application: applicationClient
};

const ApolloContext = createContext(value);

export function ApolloContextProvider(props) {
    return (
        <ApolloContext.Provider value={value}>
            {props.children}
        </ApolloContext.Provider>
    )
}

export function useApollo() {
    return useContext(ApolloContext);
}





// WEBPACK FOOTER //
// ./src/node_modules/apollo.js